import { combineEpics } from 'redux-observable';
import { Observable } from 'rxjs';

import * as ActionCreators from '../../actions/ActionCreators';
import * as ActionTypes from '../../actions/ActionTypes';
import { serialize, handleErrors } from '../../utils/ASVPUtils';

import {
    CDN_TOKEN_SERVICE_URL,
    CDN_TOKEN_APP_ID,
} from '../../constants';


const getCDNTokenServiceParams = (state) => ({
    format: 'json',
    appId: CDN_TOKEN_APP_ID,
    path: state.cdnToken.cdnTokenContentPath,
    accessTokenType: (state.videoSource.auth) ? state.cdnToken.accessTokenType : null,
    accessToken: (state.videoSource.auth) ? state.cdnToken.accessToken : null
});


const setMVPDEpic = (action$, __, { ads }) => action$
    .ofType(ActionTypes.RECEIVE_ACCESS_TOKEN)
    .pluck('payload', 'mvpd')
    .filter(Boolean)
    .do(mvpd => ads.setMVPD(mvpd))
    .ignoreElements();


const setInitialAccessToken = (action$, __, { options }) => action$
    .ofType(ActionTypes.INIT)
    .filter(() => !!options.accessToken)
    .map(() => options)
    .map(options => ActionCreators.receiveAccessToken(options.accessToken));


const fetchCDNTokenServiceEpic = (action$, store, { }) => action$
    .ofType(ActionTypes.SET_VIDEO_ID)
    .switchMap(() => Observable.combineLatest(
        action$.ofType(ActionTypes.RECEIVE_VIDEO_SOURCE),
        action$.ofType(ActionTypes.RECEIVE_MEDIA_SOURCE),
    ).take(1))
    .map(() => store.getState())
    .switchMap(state => (state.cdnToken.requiresCDNToken)
        ? Observable.fromPromise(
            fetch(`${CDN_TOKEN_SERVICE_URL}?${serialize(getCDNTokenServiceParams(state))}`)
                .then(handleErrors)
                .then(res => res.json())
                .then(response => ActionCreators.receiveCDNTokenSource(response))
                .catch(data => ActionCreators.fetchVideoSourceError(data)))
        : Observable.of(ActionCreators.receiveCDNTokenSource({})));


export default combineEpics(
    fetchCDNTokenServiceEpic,
    setInitialAccessToken,
    setMVPDEpic
);



// WEBPACK FOOTER //
// ./src/player/cdnToken/epics.js